import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "category-nav",
  "aria-label": "预设分类"
}
const _hoisted_2 = ["aria-current", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "nav-title other-nav-title"
}
const _hoisted_4 = ["aria-current", "onClick"]
const _hoisted_5 = { class: "settings-header" }
const _hoisted_6 = { class: "settings-heading" }
const _hoisted_7 = ["aria-label", "title", "aria-expanded", "aria-controls"]
const _hoisted_8 = {
  viewBox: "0 0 20 20",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  key: 0,
  d: "M4.5 6v8",
  class: "browser-icon-active"
}
const _hoisted_10 = { class: "browser-count" }
const _hoisted_11 = { class: "preset-content" }
const _hoisted_12 = {
  class: "preset-section",
  "data-preset-category": "entities",
  "aria-labelledby": "entity-presets-title"
}
const _hoisted_13 = {
  class: "status",
  role: "status"
}
const _hoisted_14 = {
  key: 0,
  role: "alert",
  class: "error"
}
const _hoisted_15 = ["data-preset-id", "aria-label"]
const _hoisted_16 = {
  key: 0,
  class: "entity-alias-field fixed-alias"
}
const _hoisted_17 = {
  key: 1,
  class: "entity-alias-field"
}
const _hoisted_18 = ["onUpdate:modelValue", "aria-label", "title"]
const _hoisted_19 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_20 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_21 = { class: "entity-guid" }
const _hoisted_22 = { class: "entity-query" }
const _hoisted_23 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_24 = {
  key: 2,
  class: "entity-actions system-badge"
}
const _hoisted_25 = ["aria-label", "onClick"]
const _hoisted_26 = {
  key: 4,
  class: "draft-hint"
}
const _hoisted_27 = {
  key: 1,
  class: "empty"
}
const _hoisted_28 = { class: "preset-footer" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  class: "preset-section",
  "data-preset-category": "skills",
  "aria-labelledby": "skill-presets-title"
}
const _hoisted_31 = {
  class: "status",
  role: "status"
}
const _hoisted_32 = {
  key: 0,
  role: "alert",
  class: "error"
}
const _hoisted_33 = ["data-preset-id", "aria-label"]
const _hoisted_34 = {
  key: 0,
  class: "fixed-alias"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_37 = {
  key: 2,
  class: "system-badge"
}
const _hoisted_38 = ["aria-label", "onClick"]
const _hoisted_39 = {
  key: 4,
  class: "draft-hint"
}
const _hoisted_40 = {
  key: 1,
  class: "empty"
}
const _hoisted_41 = { class: "preset-footer" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  class: "preset-section",
  "data-preset-category": "publicEvents",
  "aria-labelledby": "public-presets-title"
}
const _hoisted_44 = {
  class: "status",
  role: "status"
}
const _hoisted_45 = {
  key: 0,
  role: "alert",
  class: "error"
}
const _hoisted_46 = ["data-preset-id", "aria-label"]
const _hoisted_47 = {
  key: 0,
  class: "fixed-alias"
}
const _hoisted_48 = { key: 1 }
const _hoisted_49 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_50 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_51 = {
  key: 2,
  class: "parameter-preview"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = ["aria-expanded", "aria-controls", "onClick"]
const _hoisted_54 = { class: "parameter-count" }
const _hoisted_55 = ["id"]
const _hoisted_56 = { class: "duration-toggle" }
const _hoisted_57 = ["onUpdate:modelValue", "disabled", "aria-label"]
const _hoisted_58 = { class: "parameter-body" }
const _hoisted_59 = { class: "parameter-fields" }
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = ["value"]
const _hoisted_62 = ["value"]
const _hoisted_63 = ["value"]
const _hoisted_64 = { class: "parameter-actions" }
const _hoisted_65 = ["aria-label", "disabled", "onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "parameter-visibility" }
const _hoisted_68 = { class: "visibility-heading" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "visibility-controls" }
const _hoisted_71 = ["value"]
const _hoisted_72 = ["value"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = {
  key: 3,
  class: "system-badge"
}
const _hoisted_76 = ["aria-label", "onClick"]
const _hoisted_77 = {
  key: 5,
  class: "draft-hint"
}
const _hoisted_78 = {
  key: 1,
  class: "empty"
}
const _hoisted_79 = { class: "preset-footer" }
const _hoisted_80 = ["disabled"]

import StudioSelectField from "../StudioSelectField.vue";
import TypedValueInput from "../TypedValueInput.vue";
import { computed, nextTick, ref, useId, watch } from "vue";
import { useWorkspaceSettings } from "../useWorkspaceSettings";
import { isWorkspaceFeatureAvailable } from "../workspaceFeatures";
import { toast } from "vue-sonner";
import StudioHistoryToolbar from "../StudioHistoryToolbar.vue";
import { useWorkspacePresetHistory } from "./useWorkspacePresetHistory";
import SectionLayout from "@/components/Layout/SectionLayout.vue";
import StudioSidebarContent from "../StudioSidebarContent.vue";
import type { StudioEditorKind } from "../studioSidebar";
import StylePresetSection from "./StylePresetSection.vue";
import PresetEntryBrowser from "./PresetEntryBrowser.vue";
import { stylePresetCategories } from "./stylePresets";
import CustomPresetSection from "./CustomPresetSection.vue";
import MultilingualTextManager from "../MultilingualTextManager.vue";
import SaveModuleSection from "./SaveModuleSection.vue";
import { useCustomPresets } from "./customPresets";
import { referenceSources, compatibleReference } from "./presetReferences";
import { createEntityPreset } from "./entityPresets";
import { useEntityPresets } from "./useEntityPresets";
import { usePublicEventPresets } from "./usePublicEventPresets";
import { createPublicEventPreset, createPublicEventParameter, changePublicEventParameterType, PUBLIC_EVENT_PARAM_TYPES } from "./publicEventPresets";
import { useSkillAnimationPresets } from "./useSkillAnimationPresets";
import { createSkillAnimationPreset, getSkillAnimationConfigId } from "./skillAnimationPresets";


export default /*@__PURE__*/_defineComponent({
  __name: 'EntityPresetEditor',
  props: {
    editorKind: { default: "EntityPresets" }
  },
  emits: ["update:editorKind"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const activeCategory = ref("publicEvents");
const workspaceSettings = useWorkspaceSettings();
const categoryAvailable = (key: string) => isWorkspaceFeatureAvailable(key, workspaceSettings.value);
const historyElement = ref<HTMLElement>();
const presetHistory = useWorkspacePresetHistory({
  element: historyElement,
  activeFile: () => (({ entities: "EntityPresets.json", skills: "SkillAnimationPresets.json", publicEvents: "PublicEventPresets.json", custom: "CustomPresets.json", saveModules: "SaveModules.json" } as Record<string, string>)[activeCategory.value] ?? `${activeCategory.value}.json`),
  activateFile: fileName => {
    activeCategory.value = ({ "EntityPresets.json": "entities", "SkillAnimationPresets.json": "skills", "PublicEventPresets.json": "publicEvents", "CustomPresets.json": "custom", "SaveModules.json": "saveModules" } as Record<string, string>)[fileName] ?? fileName.replace(/\.json$/, "");
  },
  onError: error => toast.error(error instanceof Error ? error.message : "预设恢复失败"),
});
const custom = useCustomPresets();
const visibleStylePresetCategories = computed(() => stylePresetCategories.filter(category => categoryAvailable(category.key)));
const categories = computed(() => [{ key: "publicEvents", title: "公共事件" }, { key: "entities", title: "实体" }, { key: "skills", title: "技能动画" }, ...visibleStylePresetCategories.value, { key: "custom", title: "自定义配置" }]);
const otherCategories = computed(() => [{ key: "multilingualTexts", title: "多语言文本管理" }, { key: "saveModules", title: "存档模块" }].filter(category => categoryAvailable(category.key)));
watch([categories, otherCategories], () => {
  if (![...categories.value, ...otherCategories.value].some(category => category.key === activeCategory.value)) activeCategory.value = "publicEvents";
}, { flush: "sync" });
const isOtherCategory = computed(() => otherCategories.value.some(category => category.key === activeCategory.value));
const activeCategoryTitle = computed(() => [...categories.value, ...otherCategories.value].find(category => category.key === activeCategory.value)?.title);
const activeCategoryDescription = computed(() => activeCategory.value === "multilingualTexts"
  ? "查看客户端多语言文本，下载所需的语言文件。"
  : activeCategory.value === "saveModules" ? "每项整数按低位在左显示，依次拼接 100 项，为可跨整数的位段填写说明。"
  : "管理当前工作区共用的预设，修改后自动保存。");
const sources = computed(() => referenceSources(custom.availablePresets.value));
const styleSections = ref<InstanceType<typeof StylePresetSection>[]>([]);
const saveModuleSection = ref<InstanceType<typeof SaveModuleSection>>();

const emit = __emit;
const { customPresets: customEntities, systemPresets: systemEntities, ready, error, status, retry, flush: flushEntities, bindHistory: bindEntityHistory } = useEntityPresets();
const { customPresets: customSkills, visibleSystemPresets: systemSkills, ready: skillsReady, error: skillsError, status: skillsStatus, retry: retrySkills, flush: flushSkills, bindHistory: bindSkillHistory } = useSkillAnimationPresets();
const { customPresets: customPublicEvents, visibleSystemPresets: systemPublicEvents, ready: publicReady, error: publicError, status: publicStatus, retry: retryPublic, flush: flushPublic, bindHistory: bindPublicHistory } = usePublicEventPresets();
const entityGroups = computed(() => [
  { system: true, title: "系统默认", label: "系统人物", items: systemEntities.value },
  { system: false, title: "自定义预设", label: "人物", items: customEntities.value },
]);
const skillGroups = computed(() => [
  { system: true, title: "系统默认", label: "系统技能动画", items: systemSkills.value },
  { system: false, title: "自定义预设", label: "技能动画", items: customSkills.value },
]);
const publicGroups = computed(() => [
  { system: true, title: "系统默认", label: "系统公共事件", items: systemPublicEvents.value },
  { system: false, title: "自定义预设", label: "公共事件", items: customPublicEvents.value },
]);
const browserCollapsed = ref(false);
const browserId = useId();
const browserToggleLabel = computed(() => browserCollapsed.value ? "展开词条浏览" : "收起词条浏览");
const selectedEntry = ref<{ category: string; id: string }>();
const expandedPublicEvents = ref(new Set<string>());
const browserGroups = computed(() => categories.value.filter(category => category.key === activeCategory.value).map(category => {
  let entries: { id: string; label: string; detail: string; system: boolean }[];
  if (category.key === "publicEvents") entries = publicGroups.value.flatMap(group => group.items.map(preset => ({ id: preset.id, label: preset.alias || preset.name || "未命名公共事件", detail: preset.name, system: group.system })));
  else if (category.key === "entities") entries = entityGroups.value.flatMap(group => group.items.map(preset => ({ id: preset.id, label: preset.name || preset.talker || "未命名实体", detail: [preset.talker, preset.guid, preset.entityQuery].filter(Boolean).join(" · "), system: group.system })));
  else if (category.key === "skills") entries = skillGroups.value.flatMap(group => group.items.map(preset => ({ id: preset.id, label: preset.name || "未命名技能动画", detail: preset.configId, system: group.system })));
  else if (category.key === "custom") entries = custom.availablePresets.value.map(table => ({ id: table.id, label: table.name || "未命名配置", detail: `${table.fields.length} 个字段 · ${table.records.length} 条记录`, system: custom.systemPresets.value.some(item => item.id === table.id) }));
  else entries = styleSections.value.find(section => section.category === category.key)?.entries ?? [];
  return { key: category.key, title: category.title, entries };
}));
function togglePublicParameters(id: string) {
  if (expandedPublicEvents.value.has(id)) expandedPublicEvents.value.delete(id);
  else expandedPublicEvents.value.add(id);
}
async function selectPresetEntry(category: string, id: string) {
  activeCategory.value = category;
  selectedEntry.value = { category, id };
  await nextTick();
  const cards = historyElement.value?.querySelectorAll<HTMLElement>("[data-preset-id]");
  if (!cards) return;
  let target: HTMLElement | undefined;
  for (const card of cards) {
    card.removeAttribute("data-preset-selected");
    if (card.getAttribute("data-preset-id") === id && card.closest("[data-preset-category]")?.getAttribute("data-preset-category") === category) target = card;
  }
  if (target) {
    target.setAttribute("data-preset-selected", "true");
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    target.focus({ preventScroll: true });
  }
}
// Vue inject reads ancestors; this provider binds its own stores explicitly.
bindEntityHistory(presetHistory);
bindSkillHistory(presetHistory);
bindPublicHistory(presetHistory);
presetHistory.register("CustomPresets.json", custom.presets, custom.ready);
function addPublicPreset() { customPublicEvents.value = [...customPublicEvents.value, createPublicEventPreset()]; }
async function flush() { presetHistory.finish(); await Promise.all([flushEntities(), flushSkills(), flushPublic(), custom.flush(), saveModuleSection.value?.flush(), ...styleSections.value.map(section => section.flush())]); }
async function addSkillPreset() {
  customSkills.value = [...customSkills.value, createSkillAnimationPreset()];
  await nextTick();
  historyElement.value?.querySelector<HTMLElement>(".skill-custom-list article:last-child input")?.focus();
}
async function addPreset() {
  customEntities.value = [...customEntities.value, createEntityPreset()];
  await nextTick();
  historyElement.value?.querySelector<HTMLElement>(".entity-custom-list article:last-child input")?.focus();
}
__expose({ prepareToLeave: flush });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionLayout, {
    title: "预设设置",
    class: "entity-editor"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "historyElement",
        ref: historyElement,
        class: "settings-layout"
      }, [
        _createVNode(StudioSidebarContent, null, {
          default: _withCtx(() => [
            _createElementVNode("nav", _hoisted_1, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "nav-title" }, "预设配置", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: category.key,
                  type: "button",
                  class: _normalizeClass({ active: activeCategory.value === category.key }),
                  "aria-current": activeCategory.value === category.key ? 'page' : undefined,
                  onClick: ($event: any) => (activeCategory.value = category.key)
                }, _toDisplayString(category.title), 11, _hoisted_2))
              }), 128)),
              (otherCategories.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "其他"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherCategories.value, (category) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: category.key,
                  type: "button",
                  class: _normalizeClass({ active: activeCategory.value === category.key }),
                  "aria-current": activeCategory.value === category.key ? 'page' : undefined,
                  onClick: ($event: any) => (activeCategory.value = category.key)
                }, _toDisplayString(category.title), 11, _hoisted_4))
              }), 128)),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, [
                _createTextVNode("当前工作区"),
                _createElementVNode("br"),
                _createTextVNode("修改后自动保存")
              ], -1))
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["preset-workbench", { 'browser-collapsed': browserCollapsed.value || isOtherCategory.value }])
        }, [
          _createElementVNode("header", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "browser-toggle",
                "aria-label": browserToggleLabel.value,
                title: browserToggleLabel.value,
                "aria-expanded": !browserCollapsed.value,
                "aria-controls": _unref(browserId),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (browserCollapsed.value = !browserCollapsed.value))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                  _cache[7] || (_cache[7] = _createElementVNode("rect", {
                    x: "2.5",
                    y: "3",
                    width: "15",
                    height: "14",
                    rx: "2"
                  }, null, -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("path", { d: "M7 3v14" }, null, -1)),
                  (!browserCollapsed.value)
                    ? (_openBlock(), _createElementBlock("path", _hoisted_9))
                    : _createCommentVNode("", true)
                ])),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "词条", -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(browserGroups.value[0]?.entries.length ?? 0), 1)
              ], 8, _hoisted_7), [
                [_vShow, !isOtherCategory.value]
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h2", null, _toDisplayString(activeCategoryTitle.value), 1),
                _createElementVNode("p", null, _toDisplayString(activeCategoryDescription.value), 1)
              ])
            ]),
            _withDirectives(_createVNode(StudioHistoryToolbar, {
              history: _unref(presetHistory).current.value,
              disabled: activeCategory.value === 'entityGetMethods'
            }, null, 8, ["history", "disabled"]), [
              [_vShow, activeCategory.value !== 'multilingualTexts']
            ])
          ]),
          _createVNode(PresetEntryBrowser, {
            id: _unref(browserId),
            groups: browserGroups.value,
            "active-category": activeCategory.value,
            "selected-entry": selectedEntry.value,
            collapsed: browserCollapsed.value || isOtherCategory.value,
            onSelect: selectPresetEntry
          }, null, 8, ["id", "groups", "active-category", "selected-entry", "collapsed"]),
          _createElementVNode("main", _hoisted_11, [
            _withDirectives(_createElementVNode("section", _hoisted_12, [
              _cache[16] || (_cache[16] = _createElementVNode("header", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", { id: "entity-presets-title" }, "预设实体"),
                  _createElementVNode("p", null, "保存常用人物，以及公共事件使用的 guid 和实体查询。")
                ])
              ], -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(status)), 1),
              (_unref(error))
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(retry)().catch(() => undefined)))
                    }, "重试")
                  ]))
                : _createCommentVNode("", true),
              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "hint" }, "当前工作区共用。修改或删除预设不影响已经创建的对话。", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "hint" }, "系统默认的代号固定，人物信息及实体参数可修改。自定义预设可新增、编辑和删除。", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entityGroups.value, (group) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: group.title
                }, [
                  _createElementVNode("h4", null, _toDisplayString(group.title), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["preset-list", group.system ? 'system-items' : 'entity-custom-list'])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (preset, index) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: preset.id,
                        class: "entity-preset",
                        "data-preset-id": preset.id,
                        tabindex: "-1",
                        "aria-label": `${group.label}预设 ${index + 1}`
                      }, [
                        (group.system)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _cache[10] || (_cache[10] = _createElementVNode("span", null, "代号", -1)),
                              _createElementVNode("p", null, _toDisplayString(preset.name), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("label", _hoisted_17, [
                              _cache[11] || (_cache[11] = _createTextVNode("代号", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((preset.name) = $event),
                                class: "entity-alias",
                                "aria-label": `${group.label} ${index + 1} 代号`,
                                title: preset.name || '代号，仅用于网页显示',
                                placeholder: "代号"
                              }, null, 8, _hoisted_18), [
                                [_vModelText, preset.name]
                              ])
                            ])),
                        _createElementVNode("label", null, [
                          _cache[12] || (_cache[12] = _createTextVNode("Talker · 人名", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((preset.talker) = $event),
                            "aria-label": `${group.label} ${index + 1} Talker`,
                            placeholder: "例如：A"
                          }, null, 8, _hoisted_19), [
                            [_vModelText, preset.talker]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[13] || (_cache[13] = _createTextVNode("Subtitle · 副标题", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((preset.subtitle) = $event),
                            "aria-label": `${group.label} ${index + 1} Subtitle`,
                            placeholder: "可留空"
                          }, null, 8, _hoisted_20), [
                            [_vModelText, preset.subtitle]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_21, [
                          _cache[14] || (_cache[14] = _createTextVNode("guid", -1)),
                          _createVNode(TypedValueInput, {
                            modelValue: preset.guid,
                            "onUpdate:modelValue": ($event: any) => ((preset.guid) = $event),
                            "value-type": "Guid",
                            "aria-label": `${group.label} ${index + 1} guid`,
                            placeholder: "可留空"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label"])
                        ]),
                        _createElementVNode("label", _hoisted_22, [
                          _cache[15] || (_cache[15] = _createTextVNode("实体查询", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((preset.entityQuery) = $event),
                            "aria-label": `${group.label} ${index + 1} 实体查询`,
                            placeholder: "可留空"
                          }, null, 8, _hoisted_23), [
                            [_vModelText, preset.entityQuery]
                          ])
                        ]),
                        (group.system)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "系统"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              type: "button",
                              class: "delete entity-actions",
                              "aria-label": `删除人物预设 ${index + 1}`,
                              onClick: ($event: any) => (customEntities.value = _unref(customEntities).filter(item => item.id !== preset.id))
                            }, "删除", 8, _hoisted_25)),
                        (!preset.talker.trim())
                          ? (_openBlock(), _createElementBlock("small", _hoisted_26, "填入人名后，即可在对话中使用。"))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_15))
                    }), 128))
                  ], 2)
                ], 64))
              }), 128)),
              (_unref(ready) && !_unref(customEntities).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, "还没有自定义人物预设。点击「新建人物预设」，填写人名即可，副标题可留空。"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: !_unref(ready),
                  onClick: addPreset
                }, "＋ 新建人物预设", 8, _hoisted_29)
              ])
            ], 512), [
              [_vShow, activeCategory.value === 'entities']
            ]),
            _withDirectives(_createElementVNode("section", _hoisted_30, [
              _cache[23] || (_cache[23] = _createElementVNode("header", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", { id: "skill-presets-title" }, "预设技能动画"),
                  _createElementVNode("p", null, "保存动画名称和技能配置 ID，在 Timeline 的 Player Skill 动作中选择使用。")
                ])
              ], -1)),
              _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(skillsStatus)), 1),
              (_unref(skillsError))
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                    _createTextVNode(_toDisplayString(_unref(skillsError)) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(retrySkills)().catch(() => undefined)))
                    }, "重试")
                  ]))
                : _createCommentVNode("", true),
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "hint" }, "当前工作区共用。修改或删除预设不影响已配置的 Timeline 动作。", -1)),
              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "hint" }, "系统默认的动画名称固定，技能配置 ID 可修改。自定义预设可新增、编辑和删除。", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skillGroups.value, (group) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: group.title
                }, [
                  _createElementVNode("h4", null, _toDisplayString(group.title), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["preset-list", group.system ? 'system-items' : 'skill-custom-list'])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (preset, index) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: preset.id,
                        "data-preset-id": preset.id,
                        tabindex: "-1",
                        "aria-label": `${group.label}预设 ${index + 1}`
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "avatar" }, "动", -1)),
                        (group.system)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[19] || (_cache[19] = _createElementVNode("span", null, "动画名", -1)),
                              _createElementVNode("p", null, _toDisplayString(preset.name), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("label", _hoisted_35, [
                              _cache[20] || (_cache[20] = _createTextVNode("动画名", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((preset.name) = $event),
                                "aria-label": `${group.label} ${index + 1} 名称`,
                                placeholder: "例如：挥手"
                              }, null, 8, _hoisted_36), [
                                [_vModelText, preset.name]
                              ])
                            ])),
                        _createElementVNode("label", null, [
                          _cache[21] || (_cache[21] = _createTextVNode("配置 ID", -1)),
                          _createVNode(TypedValueInput, {
                            modelValue: preset.configId,
                            "onUpdate:modelValue": ($event: any) => ((preset.configId) = $event),
                            "value-type": "ConfigReference",
                            "aria-label": `${group.label} ${index + 1} 配置 ID`,
                            placeholder: "填写技能配置 ID"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-label"])
                        ]),
                        (group.system)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, "系统"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              type: "button",
                              class: "delete",
                              "aria-label": `删除技能动画预设 ${index + 1}`,
                              onClick: ($event: any) => (customSkills.value = _unref(customSkills).filter(item => item.id !== preset.id))
                            }, "删除", 8, _hoisted_38)),
                        (!preset.name.trim() || _unref(getSkillAnimationConfigId)(preset) === null)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_39, "填写动画名和 0–2147483647 范围内的整数配置 ID 后，即可在 Timeline 中使用。"))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_33))
                    }), 128))
                  ], 2)
                ], 64))
              }), 128)),
              (_unref(skillsReady) && !_unref(customSkills).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, "还没有自定义技能动画预设。新建后填写动画名和对应的配置 ID。"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: !_unref(skillsReady),
                  onClick: addSkillPreset
                }, "＋ 新建技能动画预设", 8, _hoisted_42)
              ])
            ], 512), [
              [_vShow, activeCategory.value === 'skills']
            ]),
            _withDirectives(_createElementVNode("section", _hoisted_43, [
              _cache[43] || (_cache[43] = _createElementVNode("header", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", { id: "public-presets-title" }, "预设公共事件"),
                  _createElementVNode("p", null, "代号用于显示和选择，事件名及参数用于执行。在 Timeline 的 Public Event 动作中选择使用。")
                ])
              ], -1)),
              _createElementVNode("p", _hoisted_44, _toDisplayString(_unref(publicStatus)), 1),
              (_unref(publicError))
                ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                    _createTextVNode(_toDisplayString(_unref(publicError)) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(retryPublic)().catch(() => undefined)))
                    }, "重试")
                  ]))
                : _createCommentVNode("", true),
              _cache[44] || (_cache[44] = _createElementVNode("p", { class: "hint" }, "当前工作区共用。显示条件与持续时间开关会同步到已配置的 Clip，事件名和参数值保留原内容。", -1)),
              _cache[45] || (_cache[45] = _createElementVNode("p", { class: "hint" }, "系统默认的代号固定，事件名及参数可修改。自定义预设可新增、编辑和删除；展开参数设置后编辑。", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publicGroups.value, (group) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: group.title
                }, [
                  _createElementVNode("h4", null, _toDisplayString(group.title), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["preset-list", group.system ? 'system-items' : 'public-custom-list'])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (preset, index) => {
                      return (_openBlock(), _createElementBlock("article", {
                        class: _normalizeClass(["public-card", { 'public-system-card': group.system }]),
                        key: preset.id,
                        "data-preset-id": preset.id,
                        tabindex: "-1",
                        "aria-label": `${group.label}预设 ${index + 1}`
                      }, [
                        (group.system)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _cache[26] || (_cache[26] = _createElementVNode("span", null, "代号", -1)),
                              _createElementVNode("p", null, _toDisplayString(preset.alias), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("label", _hoisted_48, [
                              _cache[27] || (_cache[27] = _createTextVNode("代号", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((preset.alias) = $event),
                                "aria-label": `${group.label} ${index + 1} 代号`,
                                placeholder: "例如：开门事件"
                              }, null, 8, _hoisted_49), [
                                [_vModelText, preset.alias]
                              ])
                            ])),
                        _createElementVNode("label", null, [
                          _cache[28] || (_cache[28] = _createTextVNode("事件名", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((preset.name) = $event),
                            "aria-label": `${group.label} ${index + 1} 名称`,
                            placeholder: "例如：打开大门"
                          }, null, 8, _hoisted_50), [
                            [_vModelText, preset.name]
                          ])
                        ]),
                        (group.system)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _cache[29] || (_cache[29] = _createElementVNode("span", null, "参数", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preset.parameters, (param) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: param.id
                                }, _toDisplayString(param.name) + " · " + _toDisplayString(param.type) + " · " + _toDisplayString(param.defaultValue), 1))
                              }), 128)),
                              (!preset.parameters.length)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_52, "无参数"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "parameter-toggle",
                          "aria-expanded": expandedPublicEvents.value.has(preset.id),
                          "aria-controls": `public-parameters-${group.system ? 'system' : 'custom'}-${index}`,
                          onClick: ($event: any) => (togglePublicParameters(preset.id))
                        }, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", {
                            "aria-hidden": "true",
                            class: "parameter-arrow"
                          }, "▸", -1)),
                          _cache[31] || (_cache[31] = _createTextVNode("参数设置 ", -1)),
                          _createElementVNode("span", _hoisted_54, _toDisplayString(preset.parameters.length) + " 项", 1)
                        ], 8, _hoisted_53),
                        _withDirectives(_createElementVNode("div", {
                          class: "public-parameters",
                          id: `public-parameters-${group.system ? 'system' : 'custom'}-${index}`
                        }, [
                          _createElementVNode("label", _hoisted_56, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((preset.requiresDuration) = $event),
                              type: "checkbox",
                              disabled: !_unref(publicReady),
                              "aria-label": `${group.label} ${index + 1} 是否可拖拽Clip边缘`
                            }, null, 8, _hoisted_57), [
                              [_vModelCheckbox, preset.requiresDuration]
                            ]),
                            _cache[32] || (_cache[32] = _createTextVNode("是否可拖拽Clip边缘", -1))
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "param-heading" }, [
                              _createTextVNode("参数定义 "),
                              _createElementVNode("span", null, "字符串参数从 stringParams[1] 开始，其余类型从各自列表第 0 项开始。")
                            ], -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preset.parameters, (param, paramIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: param.id,
                                class: "public-param-row"
                              }, [
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("label", null, [
                                    _cache[33] || (_cache[33] = _createTextVNode("参数名称", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((param.name) = $event),
                                      "aria-label": "公共事件参数名称",
                                      placeholder: "参数名称"
                                    }, null, 8, _hoisted_60), [
                                      [_vModelText, param.name]
                                    ])
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[34] || (_cache[34] = _createTextVNode("类型", -1)),
                                    _createVNode(StudioSelectField, {
                                      modelValue: param.type,
                                      "onUpdate:modelValue": ($event: any) => ((param.type) = $event),
                                      "aria-label": "公共事件参数类型",
                                      onChange: ($event: any) => (_unref(changePublicEventParameterType)(param))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PUBLIC_EVENT_PARAM_TYPES), (type) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: type.value,
                                            value: type.value
                                          }, _toDisplayString(type.label), 9, _hoisted_61))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[36] || (_cache[36] = _createTextVNode("值来源", -1)),
                                    _createVNode(StudioSelectField, {
                                      modelValue: param.reference,
                                      "onUpdate:modelValue": ($event: any) => ((param.reference) = $event),
                                      "aria-label": "公共事件参数预设引用"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[35] || (_cache[35] = _createElementVNode("option", { value: undefined }, "手动填写", -1)),
                                        (param.reference && !sources.value.some(source => source.value === param.reference && _unref(compatibleReference)(source, param.type)))
                                          ? (_openBlock(), _createElementBlock("option", {
                                              key: 0,
                                              value: param.reference
                                            }, "引用已失效（可重新选择）", 8, _hoisted_62))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sources.value.filter(source => _unref(compatibleReference)(source, param.type)), (source) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: source.value,
                                            value: source.value
                                          }, _toDisplayString(source.label), 9, _hoisted_63))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("label", null, [
                                    _cache[37] || (_cache[37] = _createTextVNode("默认值", -1)),
                                    _createVNode(TypedValueInput, {
                                      modelValue: param.defaultValue,
                                      "onUpdate:modelValue": ($event: any) => ((param.defaultValue) = $event),
                                      "value-type": param.type,
                                      "aria-label": "公共事件参数默认值",
                                      placeholder: "默认值（可选）"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "value-type"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "parameter-move",
                                    title: "上移参数",
                                    "aria-label": `上移参数 ${paramIndex + 1}`,
                                    disabled: paramIndex === 0,
                                    onClick: ($event: any) => (preset.parameters.splice(paramIndex - 1, 0, preset.parameters.splice(paramIndex, 1)[0]))
                                  }, "↑", 8, _hoisted_65),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "parameter-delete",
                                    onClick: ($event: any) => (preset.parameters.splice(paramIndex, 1))
                                  }, "删除参数", 8, _hoisted_66)
                                ]),
                                _createElementVNode("div", _hoisted_67, [
                                  _createElementVNode("div", _hoisted_68, [
                                    _cache[38] || (_cache[38] = _createElementVNode("span", null, "显示条件", -1)),
                                    _cache[39] || (_cache[39] = _createElementVNode("small", null, "全部满足时显示，未设置时始终显示", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "visibility-add",
                                      onClick: ($event: any) => ((param.visibleWhen ??= []).push({ parameterId: '', equals: '' }))
                                    }, "＋ 显示条件", 8, _hoisted_69)
                                  ]),
                                  _createElementVNode("div", _hoisted_70, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(param.visibleWhen || [], (rule, ruleIndex) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: ruleIndex,
                                        class: "visibility-rule"
                                      }, [
                                        _createVNode(StudioSelectField, {
                                          modelValue: rule.parameterId,
                                          "onUpdate:modelValue": ($event: any) => ((rule.parameterId) = $event),
                                          class: "condition-parameter",
                                          "aria-label": "显示条件参数"
                                        }, {
                                          default: _withCtx(() => [
                                            _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "选择参数", -1)),
                                            (rule.parameterId && !preset.parameters.some(item => item.id === rule.parameterId))
                                              ? (_openBlock(), _createElementBlock("option", {
                                                  key: 0,
                                                  value: rule.parameterId
                                                }, "参数已删除，请重新选择", 8, _hoisted_71))
                                              : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preset.parameters.filter(item => item.id !== param.id), (source) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: source.id,
                                                value: source.id
                                              }, _toDisplayString(source.name || '未命名参数'), 9, _hoisted_72))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "condition-operator" }, "等于", -1)),
                                        _createVNode(TypedValueInput, {
                                          modelValue: rule.equals,
                                          "onUpdate:modelValue": ($event: any) => ((rule.equals) = $event),
                                          class: "condition-value",
                                          "value-type": preset.parameters.find(item => item.id === rule.parameterId)?.type || 'String',
                                          "aria-label": "显示条件匹配值",
                                          placeholder: "例如：1"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "value-type"]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "condition-remove",
                                          onClick: ($event: any) => (param.visibleWhen?.splice(ruleIndex, 1))
                                        }, "删除条件", 8, _hoisted_73)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            }), 128)),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (preset.parameters.push(_unref(createPublicEventParameter)()))
                            }, "＋ 添加参数", 8, _hoisted_74)
                          ])
                        ], 8, _hoisted_55), [
                          [_vShow, expandedPublicEvents.value.has(preset.id)]
                        ]),
                        (group.system)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_75, "系统"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 4,
                              type: "button",
                              class: "delete",
                              "aria-label": `删除公共事件预设 ${index + 1}`,
                              onClick: ($event: any) => (customPublicEvents.value = _unref(customPublicEvents).filter(item => item.id !== preset.id))
                            }, "删除", 8, _hoisted_76)),
                        (!preset.name.trim())
                          ? (_openBlock(), _createElementBlock("small", _hoisted_77, "填写事件名后，即可在 Timeline 中使用。"))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_46))
                    }), 128))
                  ], 2)
                ], 64))
              }), 128)),
              (_unref(publicReady) && !_unref(customPublicEvents).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, "还没有自定义公共事件预设。新建后填写事件名，再添加所需参数。"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: !_unref(publicReady),
                  onClick: addPublicPreset
                }, "＋ 新建公共事件预设", 8, _hoisted_80)
              ])
            ], 512), [
              [_vShow, activeCategory.value === 'publicEvents']
            ]),
            _withDirectives(_createVNode(CustomPresetSection, {
              presets: _unref(custom).presets.value,
              "system-presets": _unref(custom).systemPresets.value,
              ready: _unref(custom).ready.value,
              status: _unref(custom).status.value,
              error: _unref(custom).error.value,
              onRetry: _cache[4] || (_cache[4] = ($event: any) => (_unref(custom).retry().catch(() => undefined)))
            }, null, 8, ["presets", "system-presets", "ready", "status", "error"]), [
              [_vShow, activeCategory.value === 'custom']
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleStylePresetCategories.value, (category) => {
              return _withDirectives((_openBlock(), _createBlock(StylePresetSection, {
                key: category.key,
                ref_for: true,
                ref_key: "styleSections",
                ref: styleSections,
                category: category.key,
                title: category.title,
                "reference-sources": sources.value
              }, null, 8, ["category", "title", "reference-sources"])), [
                [_vShow, activeCategory.value === category.key]
              ])
            }), 128)),
            (categoryAvailable('multilingualTexts'))
              ? _withDirectives((_openBlock(), _createBlock(MultilingualTextManager, { key: 0 }, null, 512)), [
                  [_vShow, activeCategory.value === 'multilingualTexts']
                ])
              : _createCommentVNode("", true),
            (categoryAvailable('saveModules'))
              ? _withDirectives((_openBlock(), _createBlock(SaveModuleSection, {
                  key: 1,
                  ref_key: "saveModuleSection",
                  ref: saveModuleSection
                }, null, 512)), [
                  [_vShow, activeCategory.value === 'saveModules']
                ])
              : _createCommentVNode("", true)
          ])
        ], 2)
      ], 512)
    ]),
    _: 1
  }))
}
}

})